/// <reference path="../_all.ts" />

module user {
  
  RegisterFormDirective.$inject = ['userService', '$window', 'debounce', '$q', 'partnerService', '$timeout'];
  export function RegisterFormDirective(userService: user.UserService, $window : ng.IWindowService, debounce: navigation.IDebounceService, $q : ng.IQService, partnerService : partner.PartnerService, $timeout: ng.ITimeoutService): ng.IDirective {
    return {
      restrict: 'AE',
      scope: true,
      templateUrl: 'user/RegisterFormDirective',
      link: function (scope: IRegisterFormScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {
        scope.countries = null;
        scope.request = <RegisterData>{};
        scope.setProgress(false);

        var errorToField = {      
          "srv-valid-email": "newEmail",
          "srv-username-not-taken": "newEmail",
          "srv-password-good": "newPassword",
          "srv-privacy": "privacy",
          "srv-success": "newEmail",
        }

        
        //reset server errors on change.
        var fieldsToWatch = [];
        angular.forEach(errorToField, function(value, key) { fieldsToWatch.push('registerform.' + value + '.$touched') });
        scope.$watchGroup(fieldsToWatch, (touched : boolean[], oldValue : boolean[], scope: IRegisterFormScope) => {
          if (!scope.registerform.$submitted) return; // reset only if submitted.
          if (touched.every((value, i) => { return !value; })) return;//everthing untouched? -> no action.
          angular.forEach(errorToField, function(value, key) {
            scope.registerform[errorToField[key]].$setValidity(key, true); 
          });
        })

        scope.$evalAsync(function() { $(element).find('input[name=newEmail]').focus(); } );

        scope.registerform.newEmail.$asyncValidators['username'] = (modelValue, viewValue) : ng.IPromise<any> => {

          if (scope.registerform.newEmail.$isEmpty(modelValue)) {
            // consider empty model valid
            return $q.when();
          }

          var def = $q.defer();
          
          scope.setProgress(true);
          userService.isValidUsername(modelValue).then((response) => {
            var valid : boolean   = true;
            scope.setProgress(false);
            angular.forEach(response.data, function(value, key) {
              scope.registerform.newEmail.$setValidity(key, value); 
              if (!value) valid = false;
            });

            if (valid) {              
              def.resolve();

              //kick off country loading, then it's ready when needed.
              $timeout(() => {
                scope.loadCountries()
              }, 100);

            } else {
              def.reject();
            }
          });
          return def.promise;
        };


        scope.loadCountries = function() : ng.IPromise<any> {
          return $timeout(() : ng.IPromise<any> => {
            if (scope.countries) return $q.when('already loaded');
          
            scope.setProgress(true);
            return partnerService.getPartnerData().then(function (data: partner.VendorResult) {
              scope.countries = data.Countries;
              var currentCountry = data.Countries.filter(function(val:partner.Country, index: number) :boolean {
                return val.Code == data.LocationCountryCode;
              });
              scope.request.Country = currentCountry[0]; //country of the visitor or null if not found
              scope.setProgress(false);
            });
          }, 200);
        };
        
        scope.setProgress(false);

        scope.requestAccountCreation = function() {
          if (scope.registerform.$invalid) return;

          scope.setProgress(true);
          userService.register(scope.request).then((response) => {
            var valid : boolean   = true;

            //set errors to field according to `errorToField`
            angular.forEach(response.data, function(value, key) {
              if (errorToField[key]) {
                scope.registerform[errorToField[key]].$setValidity(key, value); 
                if (!value) valid = false;
              }
            });

            scope.displayActivateMailMessage = valid;
            scope.setProgress(false);
            scope.registerform.$setUntouched();

          }, (validity: FormSrvErrorCollection) => { //error
            scope.registerform[errorToField['srv-success']].$setValidity('srv-success', false); 
            scope.setProgress(false);
            scope.registerform.$setUntouched();
          });
        };
      }

    }
  }

}